import { createAsyncThunk } from '@reduxjs/toolkit';

import { OrdersHttpGetService } from 'Feature/Common/Common/Services/OrderHttpService';
import { _apiPathManagerConfig } from 'Shared/ApiPaths/ApiPathManagerSetup';

import { IRedirectToPaymentResultInConfrimWepodQuery } from '../../types/Queries/IRedirectToPaymentResultInConfrimWepodQuery';

export const redirectToPaymentResultInConfrimWepod = createAsyncThunk(
  'Payment/redirectToPaymentResultInConfrimWepod',
  async (query: IRedirectToPaymentResultInConfrimWepodQuery) => {
    return await OrdersHttpGetService({
      url: `${_apiPathManagerConfig?.Orders.Order.RedirectToPaymentResultInConfrimWepod}`,
      params: query,

      onError: (error: any) => {
        console.warn(error);
      },
    });
  }
);
